import React, { useContext, useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import AppContext from '../AppContext';
import startFluid from '../vendor/fluid';

const Canvas = styled.canvas`
  position: fixed;
  inset: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
  pointer-events: none;
  opacity: 0.5;
  @media (prefers-reduced-motion: reduce) {
    display: none;
  }
`;

function AnimatedCanvas() {
  const canvasRef = useRef(null);
  const { darkMode } = useContext(AppContext);
  useEffect(() => startFluid(canvasRef.current, darkMode.value), [darkMode.value]);
  return <Canvas ref={canvasRef} aria-hidden="true" />;
}

function FluidBackground() {
  const { darkMode } = useContext(AppContext);
  const [reducedMotion, setReducedMotion] = useState(true);
  useEffect(() => {
    const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
    const sync = () => setReducedMotion(preference.matches);
    sync();
    preference.addEventListener('change', sync);
    return () => {
      preference.removeEventListener('change', sync);
    };
  }, []);

  return reducedMotion ? null : <AnimatedCanvas key={String(darkMode.value)} />;
}

export default FluidBackground;
